'use client';

import type { FragmentType } from '@gql';

import { useParams } from 'next/navigation';
import { useState } from 'react';
import type { NavigationMenuFragment } from './navigation-menu-gql';
import { Header, NavContainer, NavMobileMenuButtonContainer } from './navigation-menu.styles';
import { MobileMenuButton } from './partials/mobile-menu-button';
import { NavContent } from './partials/nav-content';

type Props = {
  locale: string;
} & FragmentType<typeof NavigationMenuFragment>;
export const NavigationMenu = ({ locale, ...props }: Props) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);
  const { slug } = useParams() as { slug: string };

  return (
    <Header>
      <NavContainer>
        <NavContent
          $isOpen={mobileMenuOpen}
          locale={locale}
          slug={slug}
          onClick={() => setMobileMenuOpen(false)}
          {...props}
        />

        <NavMobileMenuButtonContainer>
          <MobileMenuButton $isOpen={mobileMenuOpen} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} />
        </NavMobileMenuButtonContainer>
      </NavContainer>
    </Header>
  );
};
